<template>
  <v-sheet class="grey lighten-1">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="pt-8 pt-md-10 pb-sm-16 pb-10 item">
        <v-row v-if="item.title" justify="center">
          <v-col cols="12" sm="10" md="9">
            <TitleWidget class="text-center">{{ item.title }}</TitleWidget>

            <img
              v-if="image"
              class="d-block mt-4 item-img"
              :src="files + image + '?resize=1&w=960'"
              :alt="item.title"
              width="100%"
            />

            <div
              v-if="item.text"
              class="
                grey--text
                text--darken-1
                mt-6 mt-sm-8
                ck-content
                item-text
              "
              v-html="item.text"
            ></div>

            <div v-if="images.length" class="mt-12">
              <TitleWidget class="text-center" small>
                Galeria de Fotos
              </TitleWidget>

              <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null"
              />

              <div class="mt-8 images-grid-list">
                <img
                  class="d-block cursor-pointer"
                  @click="index = keyImages"
                  :src="img + '?resize=1&w=300'"
                  width="100%"
                  v-for="(img, keyImages) in images"
                  :key="keyImages"
                />
              </div>
            </div>
          </v-col>
        </v-row>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
const _config = {
  mod: "about",
};
export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      return this.item.imgs &&
        this.item.imgs.featured &&
        this.item.imgs.featured.path
        ? this.item.imgs.featured.path
        : "";
    },
    images() {
      const images = [];
      if (this.item.imgs && this.item.imgs.list && this.item.imgs.list.length)
        this.item.imgs.list.map(({ path }) => {
          if (path != this.image) images.push(this.files + path);
        });
      return images;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);
  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
